module.exports = __webpack_public_path__ + "img/lemon_drop_martini.57bcceb0.jpg";